import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import { specialDealsApi } from "../../api/specialDeals";
import "./specialDeals.css";

export default function SpecialDealsHome() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setFailed(false);
    specialDealsApi.home(controller.signal).then(result => {
      if (!controller.signal.aborted) setData(result);
    }).catch(error => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, [retry]);
  if (failed) return <section className="container special-deals-home"><p role="status">Unable to load Our Special Deals. <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setRetry(value => value + 1)}>Retry</button></p></section>;
  if (!data || !data.visible || !data.products.length) return null;
  return <section className="special-deals-home" aria-label={data.title}>
    <BlockProductsCarousel title={data.title} subtitle={data.subtitle} layout="grid-4" products={data.products} />
    <div className="container special-deals-home__more"><Link className="btn btn-primary" to="/special-deals">View More <span aria-hidden="true">→</span></Link></div>
  </section>;
}
